const APP_ID = import.meta.env.VITE_INTERCOM_APP_ID

declare global {
  interface Window {
    Intercom: any
    intercomSettings: any
  }
}

async function loadIntercom() {
  return new Promise((resolve) => {
    if (window.Intercom) {
      window.Intercom('update', window.intercomSettings)
      return resolve(true)
    }

    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.defer = true
    script.src = `https://widget.intercom.io/widget/${APP_ID}`
    script.onload = resolve
    document.head.appendChild(script)
  })
}

export async function install(app) {
  const { sessionData } = useSessionData()
  const intercomEnabled = sessionData.featureflags.provider_intercom
  if (!intercomEnabled)
    return

  window.intercomSettings = {
    app_id: APP_ID,
    created_at: Date.now(),
    hide_default_launcher: true,
    ...(
      sessionData.isAuthenticated
        ? {
            email: sessionData.user.email,
            created_at: Date.now(),
          }
        : {}
    ),
  }
  const wasAlreadyBooted = await loadIntercom()
  if (!wasAlreadyBooted)
    window.Intercom('boot', window.intercomSettings)
  app.provide('intercom', window.Intercom)
}
